import { render } from "./HeroiconsSolidRefresh.vue?vue&type=template&id=2e588462"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidRefresh.vue"]])

export default __exports__